import { Input, InputProps } from "antd";
import classnames from "classnames";
import styles from "./styles.module.scss";
import EyeVisibleOutlined from "../../assets/images/EyeVisibleOutlined.svg";
import EyeOutlined from "../../assets/images/EyeOutlined.svg";
import { MaxLength } from "../../constants/index";
export interface IProps extends InputProps {
  isPassword?: boolean;
  className?: string;
}
const CommonInput = (props: IProps) => {
  const {
    isPassword = false,
    className,
    maxLength = MaxLength.INPUT,
    ...rest
  } = props;

  return isPassword ? (
    <div className={styles.inputWrapper}>
      <Input.Password
        className={classnames(styles.input, className)}
        iconRender={(visible) => {
          return visible ? (
            <img src={EyeOutlined} alt="eye-icon"></img>
          ) : (
            <img src={EyeVisibleOutlined} alt="eye-icon"></img>
          );
        }}
        {...rest}
        maxLength={maxLength}
      />
    </div>
  ) : (
    <div className={styles.inputWrapper}>
      <Input
        className={classnames(styles.input, className)}
        maxLength={maxLength}
        {...rest}
      />
    </div>
  );
};
export default CommonInput;
